export enum adminCompanyRecruiterTypes {
    FETCH_ADMIN_COMPANY_RECRUITER_REQUEST = "FETCH_ADMIN_COMPANY_RECRUITER_REQUEST",
    FETCH_ADMIN_COMPANY_RECRUITER_SUCCESS = "FETCH_ADMIN_COMPANY_RECRUITER_SUCCESS",
    FETCH_ADMIN_COMPANY_RECRUITER_FAILURE = "FETCH_ADMIN_COMPANY_RECRUITER_FAILURE",
  }